import { render, staticRenderFns } from "./page3.vue?vue&type=template&id=78c0bd8c&scoped=true&"
import script from "./page3.vue?vue&type=script&lang=js&"
export * from "./page3.vue?vue&type=script&lang=js&"
import style0 from "./page3.vue?vue&type=style&index=0&id=78c0bd8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c0bd8c",
  null
  
)

export default component.exports